import type { EligibilityCheckDoc } from '../types'
import type { TerminalState, TerminalReason } from '../../shared/terminalState'
import { classifyTerminal } from '../../shared/terminalState'
import { MAX_RETRIES } from '../../shared/retryPolicy'

/**
 * Classifies a check into a terminal state/reason at read time. The classifier
 * lives in `shared/terminalState.ts` so it can run on either side; we don't
 * persist the result on the doc — every render re-derives from the existing
 * status/outcome/result/rejection fields (plus `lastError`, which preserves
 * the cause when the sweep overwrites `error` with the exhaustion message).
 *
 * Returns null only for non-terminal checks (pending, or timeout still in retry).
 */
export function readTerminal(check: EligibilityCheckDoc): { state: TerminalState; reason: TerminalReason } | null {
  const retryCount = check.retryCount
  const c = classifyTerminal({
    status: check.status,
    outcome: check.outcome,
    success: check.success,
    resultStatus: check.result?.status,
    rejectionCategory: check.result?.rejection?.category ?? check.rejectionCategory,
    type: check.type,
    lastError: check.lastError,
    error: check.error,
    retryCount,
    retriesExhausted: retryCount !== undefined && retryCount >= MAX_RETRIES,
    eyemedAllServicesNo: check.eyemedAllServicesNo,
  })
  return c ? { state: c.terminalState, reason: c.terminalReason } : null
}
